module.exports = __webpack_public_path__ + "img/category-sport-hover.e1167728.png";